"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get_segments_by_eval = void 0; // Passer tout ça en hook

var get_segments_by_eval = function get_segments_by_eval(evaluations, defaultSegmentColors) {
  // calcul des segments pour le graph basé sur les ranges des évaluations
  // retourne un array sous cette forme : [0, 40, 60, 80, 100]
  var segmentByEvalRange = [];
  var segmentColorsByEvalRange = [];
  evaluations.map(function (e, i) {
    if (i === 0) {
      segmentByEvalRange.push(e.min);
    }

    segmentByEvalRange.push(e.max);
    e.color && segmentColorsByEvalRange.push(e.color);
    return e;
  }); // si pas de couleurs définies, on pioche dans les couleurs par défaut
  // en fonction du nombre de ranges définie dans le questionnaire ou la partie

  if (!segmentColorsByEvalRange.length) {
    segmentColorsByEvalRange = defaultSegmentColors[evaluations.length - 2];
  }

  return [segmentByEvalRange, segmentColorsByEvalRange];
};

exports.get_segments_by_eval = get_segments_by_eval;